import { defineMessages } from "react-intl";

export const objectSelectionGridMessages = defineMessages({
  selectObjects: {
    defaultMessage: "Select object(s)",
    id: "object-selection-grid-messages.select-object(s)",
  },
});
